var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.94111,
    cy: 4.904,
    r: 4.404,
    fill: "#888888"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.52344 16.7273C1.52344 12.0329 5.32902 8.22729 10.0234 8.22729V8.22729C14.7179 8.22729 18.5234 12.0329 18.5234 16.7273V19.5606H1.52344V16.7273Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.536bb956c575150a086702f17ed6f130.svg";
export { ForwardRef as ReactComponent };